export const setSimpleFormConfig = payload => ({
  type: 'SET_SIMPLE_FORM_CONFIG',
  payload,
})

export const setSimpleFormSmartContract = payload => ({
  type: 'SET_SIMPLE_FORM_SMART_CONTRACT',
  payload,
})
